export default "__VITE_ASSET__cgV4MUkW__"